package domain.pieces

import engine.controller.PieceRandomizer
import engine.model.Piece

class BagRandomizer(
    private val availablePieces: Collection<Piece>,
    private val previewCount: Int
) : PieceRandomizer {

    private val queue: MutableList<Piece> = mutableListOf()

    init {
        ensureQueue()
    }

    override fun getNextPiece(): Piece {
        ensureQueue()
        return queue.removeAt(0).also { ensureQueue() }
    }

    override fun getPreview(count: Int): List<Piece> {
        ensureQueue()
        return queue.take(count)
    }

    override fun reset() {
        queue.clear()
        ensureQueue()
    }

    private fun ensureQueue() {
        while (queue.size < previewCount + 1) {
            queue.addAll(availablePieces.shuffled())
        }
    }
}
